(function arrowNavigation(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.Event ||
    !global.NewHomeSource.FullImageViewer.Config ||
    !global.NewHomeSource.FilmStrip) {
    return;
  }

  const previousArrowNavigation = global.NewHomeSource.ArrowNavigation;
  const queryArrowDown = '[data-full-image-viewer-role="down"]';
  const queryArrowLeft = '[data-full-image-viewer-role="left"]';
  const queryArrowRight = '[data-full-image-viewer-role="right"]';
  const queryArrowUp = '[data-full-image-viewer-role="up"]';
  const downElement = global.document.querySelector(queryArrowDown);
  const eventToAttach = global.NewHomeSource.FullImageViewer.Config.getClickOrTouchEvent();
  const leftElement = global.document.querySelector(queryArrowLeft);
  const rightElement = global.document.querySelector(queryArrowRight);
  const upElement = global.document.querySelector(queryArrowUp);
  const callbackMove = global.NewHomeSource.FilmStrip.move;
  const visible = 'visible';
  const hidden = 'hidden';

  /**
   * @private
   * render: renders the arrows according to the information available.
   *
   * @param {object} data with the information to display or hide the arrows.
   */
  function render(data) {
    const state = global.NewHomeSource.FullImageViewerState.get();

    if (data.TotalImages > 1 || state.TotalCollections > 1) {
      leftElement.style.visibility = visible;
      rightElement.style.visibility = visible;
    } else {
      leftElement.style.visibility = hidden;
      rightElement.style.visibility = hidden;
    }
  }

  /**
   * @private
   * render: renders the arrows according to the information available.
   *
   * @param {object} data with the information to display or hide the arrows.
   */
  function renderCollectionSet(data) {
    if (data.TotalImages > 1) {
      downElement.style.visibility = visible;
      upElement.style.visibility = visible;
    } else {
      upElement.style.visibility = hidden;
      downElement.style.visibility = hidden;
    }
  }

  /**
   * @private
   * isSelected: returs the value of the IsSelected property.
   *
   * @param {object} element that is being evaluated.
   */
  function isSelected(element) {
    return element.IsSelected;
  }

  /**
   * @constructs NewHomeSource.ArrowNavigation
   */
  function ArrowNavigation() {
  }

  /**
   * @public
   * onMoveDown: moves the image being displayed to the next one.
   * If not more images are available in the current collection, will not move.
   */
  ArrowNavigation.onMoveDown = function onMoveDown() {
    const state = global.NewHomeSource.FullImageViewerState.get();
    const selectedIndex = state.images.findIndex(isSelected);
    const newIndex = selectedIndex + 1;

    if (newIndex === state.images.length ||
      state.images[selectedIndex].Collection !== state.images[newIndex].Collection) {
      return;
    }

    global.NewHomeSource.FullImageViewerState.setImage(state.images[newIndex]);
  };

  /**
   * @public
   * onMoveLeft: moves the image being displayed to the previous one.
   * If not more images are available in the current collection, will move to the previous collection.
   */
  ArrowNavigation.onMoveLeft = function onMoveLeft() {
    const state = global.NewHomeSource.FullImageViewerState.get();
    const selectedIndex = state.images.findIndex(isSelected);
    let newIndex = selectedIndex - 1;

    if (newIndex < 0) {
      newIndex = state.images.length - 1;
    }

    global.NewHomeSource.FullImageViewerState.setImage(state.images[newIndex]);
  };

  /**
   * @public
   * onMoveRight: moves the image being displayed to the next one.
   * If not more images are available in the current collection, will move to the next collection.
   */
  ArrowNavigation.onMoveRight = function onMoveRigth() {
    const state = global.NewHomeSource.FullImageViewerState.get();
    const selectedIndex = state.images.findIndex(isSelected);
    let newIndex = selectedIndex + 1;

    if (newIndex >= state.images.length) {
      newIndex = 0;
    }

    global.NewHomeSource.FullImageViewerState.setImage(state.images[newIndex]);
  };

  /**
   * @public
   * onMoveRight: moves the image being displayed to the previous one.
   * If not more images are available in the current collection, will not move.
   */
  ArrowNavigation.onMoveUp = function onMoveUp() {
    const state = global.NewHomeSource.FullImageViewerState.get();
    const selectedIndex = state.images.findIndex(isSelected);
    const newIndex = selectedIndex - 1;

    if (newIndex < 0 || state.images[selectedIndex].Collection !== state.images[newIndex].Collection) {
      return;
    }

    global.NewHomeSource.FullImageViewerState.setImage(state.images[newIndex]);
  };

  /**
   * @private
   * onKeyDown: moves the image to the left or right according to the key pressed.
   *
   * @param {KeyboardEvent} event with the information related to key pressed.
   */
  function onKeyDown(event) {
    if (event.keyCode === 37) {
      ArrowNavigation.onMoveLeft();
    } else if (event.keyCode === 38) {
      ArrowNavigation.onMoveUp();
    } else if (event.keyCode === 39) {
      ArrowNavigation.onMoveRight();
    } else if (event.keyCode === 40) {
      ArrowNavigation.onMoveDown();
    }
  }

  const events = {
    moveDown: {
      callbacks: [ArrowNavigation.onMoveDown, callbackMove],
      elements: queryArrowDown,
      events: [eventToAttach],
    },
    moveLeft: {
      callbacks: [ArrowNavigation.onMoveLeft, callbackMove],
      elements: queryArrowLeft,
      events: [eventToAttach],
    },
    moveUp: {
      callbacks: [ArrowNavigation.onMoveUp, callbackMove],
      elements: queryArrowUp,
      events: [eventToAttach],
    },
    moveRight: {
      callbacks: [ArrowNavigation.onMoveRight, callbackMove],
      elements: queryArrowRight,
      events: [eventToAttach],
    },
    keyboard: {
      callbacks: [onKeyDown, global.NewHomeSource.FilmStrip.moveArrow],
      elements: '[data-component="full-image-viewer"]',
      events: ['keydown'],
    },
  };

  /**
   * @public
   * update: this method will be called by the Event Bus when the data is updated.
   *
   * @param {object} data information that was changed.
   * @param {string} topic that was triggered by the Event Bus.
   */
  ArrowNavigation.update = function update(data, topic) {
    requestAnimationFrame(render.bind(this, data));

    if (topic === 'onCollectionSet') {
      requestAnimationFrame(renderCollectionSet.bind(this, data));
    }
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.SampleModule to the previous script.
   */
  ArrowNavigation.noConflict = function noConflict() {
    global.NewHomeSource.ArrowNavigation = previousArrowNavigation;
    return ArrowNavigation;
  };

  global.NewHomeSource.Event(events);
  global.NewHomeSource.FullImageViewerState.add('onCollectionSet', ArrowNavigation);
  global.NewHomeSource.ArrowNavigation = ArrowNavigation;
}(window));
